import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
import { TruncatedText } from "./TruncatedText.js";
function Title({
  children
}) {
  return /* @__PURE__ */ jsx(StyledTitleContainer, {
    children: /* @__PURE__ */ jsx(TruncatedText, {
      children
    })
  });
}
const StyledTitleContainer = styled.div.withConfig({
  displayName: "StyledTitleContainer",
  componentId: "sc-1g5z2x4-0"
})(["", " display:flex;align-items:center;box-sizing:border-box;height:32px;padding:0 ", ";color:", ";"], textStyles.uiTextS, token.spacing4, token.colorText);
export {
  Title
};
//# sourceMappingURL=Title.js.map
